// Cashier Debit & Credit Transactions Mutations

export const updateDebitCreditList = (state, payload) => {
  state.debitCreditList = payload
}

export const setDebitCreditInfo = (state, payload) => {
  state.debitCreditInfo = payload
}
